import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M5 4v3h5.5v12h3V7H19V4z" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoTextx');
